
  import { HI_ZURICH_PHONES } from '@/constants/insurance';
  export default {
    props: {
      count: { type: Number, default: 0 },
      product: { type: String, default: '' },
      dataAttrs: { type: Object, default () { return {}; } },
      tabs: { type: Object, default () { return {}; } }
    },
    computed: {
      search () {
        return this.$store.getters['search/get'];
      },
      phoneZurich () {
        return HI_ZURICH_PHONES[0];
      },
      zurichError () {
        const error = this.search.errorList.error[0].errorDescription.toLowerCase().trim();
        return (error.includes('wall') || error.includes('roof') || error.includes('claims'));
      }
    }
  };
